import { ShoppingCart, Tag } from "lucide-react";
import { fmtMoney } from "./plazaLib";

export default function ShopTopBar({ cartCount, onOpenCart, wallet }) {
  return (
    <header className="hpz-shop__topbar" data-testid="plaza-topbar">
      <div className="hpz-shop__brand">
        <span className="hpz-shop__brand-mark">HP</span>
        <span>HustlePlaza</span>
      </div>
      <div className="hpz-shop__topbar-actions">
        {wallet?.balance_cents > 0 && (
          <span className="hpz-shop__wallet" data-testid="plaza-wallet-chip">
            <Tag size={14} /> ${fmtMoney(wallet.balance_cents)} credit
          </span>
        )}
        <button
          className="hpz-shop__cart-btn"
          onClick={onOpenCart}
          data-testid="plaza-cart-open"
          aria-label="Open cart"
        >
          <ShoppingCart size={18} />
          {cartCount > 0 && <span className="hpz-shop__cart-count">{cartCount}</span>}
        </button>
      </div>
    </header>
  );
}
